<template>
  <AppLayout :enable-footer="false">
    <VContainer
      px-0
      py-0
      fluid
      id="register-page"
      class="overflow-x-hidden overflow-y-auto"
      style="height: calc(100vh - 24px);"
    >
      <VRow
        align-center
        fill-height
        justify-center
      >
        <VCol
          lg="6"
          md="8"
          sm="12"
        >
          <RegisterForm />
        </VCol>
      </VRow>
    </VContainer>
  </AppLayout>
</template>

<script>
import AppLayout from "@/layouts/AlternateAppLayout";
import RegisterForm from "@/components/Register";

export default {
  name: "Register",
  components: {
    RegisterForm,
    AppLayout
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss">
/** extra imports **/
@import "../styles/variables.scss";
</style>